import React from 'react';

/**
 * Marker component per definire una scheda.
 * Props supportate:
 * - eventKey (string)  : identificatore univoco della tab (obbligatorio)
 * - label (node)       : etichetta della tab
 * - icon (string)      : classe FA opzionale (es. "fa-plane")
 * - badge (number|node): contenuto del badge opzionale
 * - disabled (bool)    : disabilita la tab
 * - children (node)    : contenuto del pannello
 */
const Tab = ({ children }) => {
  // Non renderizza da sola; TabsContainer leggerà le props e i children.
  return null;
};

export default Tab;
